import React from 'react';
import { Users, Target, Award, TrendingUp } from 'lucide-react';
import { mockStats } from '../data/mock';

export const About = () => {
  const values = [
    {
      icon: Users,
      title: "Team Giovane",
      description: "Un team di professionisti giovani e dinamici pronti ad affrontare ogni sfida"
    },
    {
      icon: Target,
      title: "Precisione",
      description: "Attenzione maniacale ai dettagli in ogni fase del lavoro"
    },
    {
      icon: Award,
      title: "Qualità",
      description: "Solo materiali certificati e tecniche all'avanguardia"
    },
    {
      icon: TrendingUp,
      title: "Crescita",
      description: "Voglia di crescere e migliorarci costantemente per te"
    }
  ];

  return (
    <section id="chi-siamo" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div className="space-y-8">
            <div>
              <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
                Chi Siamo
              </h2>
              <div className="space-y-4 text-lg text-gray-600 leading-relaxed">
                <p>
                  Siamo <span className="font-semibold text-blue-600">ragazzi giovani con grande passione</span> per il nostro lavoro, ci dedichiamo alla soddisfazione del cliente con servizi sempre rapidi e veloci, capaci di adattarsi alle nuove tecnologie ed alle nuove esigenze e sfide che impone il mercato.
                </p>
                <p>
                  Operiamo nella zona di Modena e provincia, offrendo servizi di idraulica e ristrutturazione con il massimo dell'impegno.
                </p>
                <p>
                  La nostra filosofia è semplice: <span className="font-semibold text-orange-600">precisione e attenzione ai dettagli</span> in ogni intervento, grande o piccolo che sia. Non tralasciamo nulla, perché sappiamo che ogni dettaglio conta.
                </p>
              </div>
            </div>

            {/* Values Grid */}
            <div className="grid sm:grid-cols-2 gap-6">
              {values.map((value, index) => {
                const Icon = value.icon;
                return (
                  <div key={index} className="flex gap-4">
                    <div className="flex-shrink-0">
                      <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                        <Icon className="w-6 h-6 text-blue-600" />
                      </div>
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-900 mb-1">{value.title}</h3>
                      <p className="text-sm text-gray-600">{value.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Stats */}
          <div className="relative">
            <div className="grid grid-cols-2 gap-6">
              {mockStats.map((stat, index) => (
                <div 
                  key={index}
                  className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border-2 border-gray-100"
                >
                  <div className="text-4xl sm:text-5xl font-bold bg-gradient-to-r from-blue-600 to-orange-500 bg-clip-text text-transparent mb-2">
                    {stat.number}
                  </div>
                  <div className="text-gray-600 font-medium">{stat.label}</div>
                </div>
              ))}
            </div>

            {/* Background decoration */}
            <div className="absolute -z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-gradient-to-br from-blue-100 to-orange-100 rounded-3xl blur-3xl opacity-30"></div>
          </div>
        </div>
      </div>
    </section>
  );
};
